import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ProductCardService } from '../../services/product-card.service';
import { Subscription } from 'rxjs';
import { FiltersPanelService } from '../filters-panel/filters-panel.service';

import { SHARED_MODULES } from '../../../shared.';
import { FiltersPanelComponent } from '../filters-panel/filters-panel.component';
import { ProductCardComponent } from '../product-card/product-card.component';

@Component({
    selector: 'app-product-card-drawer',
    templateUrl: './product-card-drawer.component.html',
    styleUrls: ['./product-card-drawer.component.scss'],
	imports: [SHARED_MODULES, FiltersPanelComponent, ProductCardComponent],
    providers: [FiltersPanelService],
    standalone: true
})
export class ProductCardDrawerComponent implements OnInit, OnDestroy {

	private _subscriptions: Array<Subscription> = [];

	public opened: boolean = false;

	@Input('hasBackdrop') hasBackdrop: boolean = false;
	@Input('shopId') shopId: number;

	constructor(private productCardService: ProductCardService, private filtersPanelService: FiltersPanelService) {}

	ngOnInit(): void {
		this._subscriptions.push(
			this.productCardService.openSubject.subscribe(() => this.opened = true),
			this.productCardService.closeSubject.subscribe(() => {
				this.opened = false;
				this.filtersPanelService.setFilters([]);
			})
		);
	}

	public onClose(): void {
		this.productCardService.close({ force: false});
	}

	ngOnDestroy(): void {
		this._subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
	}
}
